export function isValidBase64(value: string | null | undefined) {
  value = value?.trim()
  if (!value) return false
  if (value.length % 4 !== 0) return false

  // Base64 pattern: Only contains A-Z, a-z, 0-9, +, /, and optionally =
  const base64Pattern = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/
  return base64Pattern.test(value)
}
